import { inject, type Ref } from 'vue'

export function useStorefrontPrefix() {
    const storefrontPrefix = inject<Ref<string>>('STOREFRONT_PREFIX')
    if (storefrontPrefix === undefined) {
        throw new Error('No storefront prefix found')
    }

    return storefrontPrefix
}
